import { useState, useCallback } from 'react';
import useBrands from 'data/hooks/useBrands';

const useConnect = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEnableModalOpen, setIsEnableModalOpen] = useState<boolean>(false);
  const { brands, isLoading: isLoadingBrands } = useBrands();

  const handleOpenModal = useCallback(() => {
    setIsModalOpen(true);
  }, [setIsModalOpen]);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, [setIsModalOpen]);

  const handleOpenEnableModal = useCallback(() => {
    setIsEnableModalOpen(true);
  }, [setIsEnableModalOpen]);

  const handleCloseEnableModal = useCallback(() => {
    setIsEnableModalOpen(false);
  }, [setIsEnableModalOpen]);

  return {
    isLoading: isLoadingBrands,
    brands,
    handleOpenModal,
    handleCloseModal,
    isModalOpen,
    handleOpenEnableModal,
    handleCloseEnableModal,
    isEnableModalOpen,
  };
};

export default useConnect;
